import React from 'react'

const PerPageSelect = ({ value, onChange, options = [10, 25, 50, 100] }) => {
  return (
    <label className="flex items-center gap-2 text-sm whitespace-nowrap">
      <span className="text-muted">Tampilkan</span>
      <select
        className="h-8 rounded-lg border border-line bg-white px-2 text-sm text-ink outline-none focus:border-accent"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span className="text-muted">per halaman</span>
    </label>
  )
}

export default PerPageSelect
